/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */

import React, { useState, useEffect } from "react";
import ReactCrop from "react-image-crop";

import PropTypes from "prop-types";

import API from "../../../../api";

import SVG from "../../../../components/SVG";

// eslint-disable-next-line import/imports-first
import "react-image-crop/lib/ReactCrop.scss";
import "./avatar-upload.scss";
import styles from "./avatar-upload.module.scss";

const AvatarUpload = ({ photo, type }) => {
  const [crop, setCrop] = useState({
    unit: "%",
    width: 100,
    aspect: 1 / 1
  });

  const [selectedFile, setSelectedFile] = useState("");
  const [src, setSrc] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [croppedImageFile, setCroppedImageFile] = useState(null);

  const [imageRef, setImageRef] = useState(null);

  const resetState = () => {
    setSrc(null);
    setCroppedImage(null);
    setCroppedImageFile(null);
    setImageRef(null);
    setSelectedFile("");
  };

  const handleFile = e => {
    const fileReader = new FileReader();

    fileReader.onloadend = () => {
      setSrc(fileReader.result);
    };

    if (e.target.files[0]) {
      fileReader.readAsDataURL(e.target.files[0]);
    }
  };

  const updProfAvatar = () => {
    const formData = new FormData();
    formData.append("photo", croppedImageFile);
    API.user
      .updateAvatar({
        data: formData,
        headers: { "Content-Type": "multipart/form-data; " }
      })
      .then(() => {
        resetState();
        API.user.getUserInfo();
      });
  };

  const updCompanyAvatar = () => {
    const formData = new FormData();
    formData.append("logo", croppedImageFile);
    API.user
      .updateCompanyLogo({
        data: formData,
        headers: { "Content-Type": "multipart/form-data; " }
      })
      .then(() => {
        resetState();
        API.user.getUserInfo();
      });
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (croppedImageFile) {
      if (type === "profileAvatar") {
        updProfAvatar();
      }
      if (type === "companyAvatar") {
        updCompanyAvatar();
      }
    }
  };

  const onCropChange = cropData => {
    setCrop(cropData);
  };

  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    // eslint-disable-next-line no-plusplus
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const croppedImgFile = new File([u8arr], filename, { type: mime });

    setCroppedImageFile(croppedImgFile);
  };

  const getCroppedImg = (image, cropData) => {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = cropData.width;
    canvas.height = cropData.height;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#c4c4c4";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.drawImage(
      image,
      cropData.x * scaleX,
      cropData.y * scaleY,
      cropData.width * scaleX,
      cropData.height * scaleY,
      0,
      0,
      cropData.width,
      cropData.height
    );

    const reader = new FileReader();

    const base64Image = canvas.toDataURL("image/jpeg");

    setCroppedImage(base64Image);

    canvas.toBlob(blob => {
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        dataURLtoFile(reader.result, "avatar.png");
      };
    });
  };

  const onCropComplete = cropData => {
    if (imageRef && cropData.width && cropData.height) {
      getCroppedImg(imageRef, cropData);
    }
  };

  const onImageLoaded = image => {
    setImageRef(image);
    const defaultCrop = {
      unit: "px",
      aspect: 1 / 1,
      x: 0,
      y: 0,
      width: image.width,
      height: image.height
    };
    setCrop(defaultCrop);
  };

  const handleCancel = e => {
    e.stopPropagation();
    e.preventDefault();

    resetState();
  };

  useEffect(() => {
    onCropComplete(crop);
    // eslint-disable-next-line
  }, [imageRef]);

  return (
    <div className={styles["avatar-container"]}>
      <div className={styles["left-column"]}>
        <div className={styles.avatar}>
          {photo ? (
            <img
              className={styles.image}
              src={croppedImage || photo}
              alt="avatar"
            />
          ) : null}
        </div>

        <form onSubmit={handleSubmit}>
          <label
            className={styles["upload-photo-button"]}
            htmlFor={`profile_pic_${type}`}
          >
            <SVG.Download width={26} height={22} />
            Upload photo
          </label>
          <input
            className={styles["file-upload"]}
            type="file"
            value={selectedFile}
            id={`profile_pic_${type}`}
            onChange={handleFile}
          />
          {src && (
            <>
              <button
                type="submit"
                className={styles["upload-photo-button"]}
                style={{ marginTop: 10, marginBottom: 10 }}
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button type="submit" className={styles["save-button"]}>
                Save
              </button>
            </>
          )}
        </form>
      </div>
      <div className={styles["right-column"]}>
        {src && (
          <div className={styles["crop-container"]}>
            <ReactCrop
              minWidth={100}
              minHeight={100}
              src={src}
              crop={crop}
              onImageLoaded={onImageLoaded}
              onComplete={onCropComplete}
              onChange={onCropChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

AvatarUpload.propTypes = {
  photo: PropTypes.string,
  type: PropTypes.string
};

AvatarUpload.defaultProps = {
  photo: "",
  type: "profileAvatar"
};

export default AvatarUpload;
